import Vue from 'vue';

// Register our filters globally
Vue.filter('capitalize', require('./capitalize').default);
Vue.filter('getInitial', require('./getInitial').default);
Vue.filter('getFormattedDate', require('./getFormattedDate').default);
Vue.filter('getFullDay', require('./getFullDay').default);
Vue.filter('formatPrice', require('./formatPrice').default);
Vue.filter('twoDigits', require('./twoDigits').default);
